__turbopack_context__.v({
  "name": "spec-item-module-scss-module__iGra-a__name",
  "specItem": "spec-item-module-scss-module__iGra-a__specItem",
  "value": "spec-item-module-scss-module__iGra-a__value",
});
